import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Typography from '@material-ui/core/Typography'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import { toggleLaundryVisibility } from '../../actions/Config'
import strings from './strings'

class SettingsContent extends React.Component {
  handleToggleLaundryVisibility = () => {
    const { data, user, toggleLaundryVisibility } = this.props
    if (data.community && user.token) {
      toggleLaundryVisibility()
    }
  }

  render() {
    const { classes, data } = this.props
    const { community } = data

    if (!community) {
      return null
    }

    return (
      <div className={classes.root}>
        <Typography variant="h4" gutterBottom>
          {strings.title}
        </Typography>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <FormControlLabel
                control={
                  <Switch
                    classes={{
                      switchBase: classes.switchBase,
                      checked: classes.checked,
                      bar: classes.bar
                    }}
                    checked={community.showApartmentInLaundry || false}
                    onChange={this.handleToggleLaundryVisibility}
                    value="showApartmentInLaundry"
                  />
                }
                label={strings.showApartmentInLaundry}
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3
  },
  paper: {
    padding: theme.spacing.unit * 2
  },
  switchBase: {
    '&$checked': {
      color: '#4caf50'
    },
    '&$checked + $bar': {
      backgroundColor: '#4caf50'
    }
  },
  checked: {},
  bar: {}
})

SettingsContent.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  toggleLaundryVisibility: PropTypes.func.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ toggleLaundryVisibility }, dispatch)
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(SettingsContent) 


// WEBPACK FOOTER //
// ./src/components/pages/Settings/SettingsContent.js